// extracted by mini-css-extract-plugin
export default {"button":"TnSnappboxDropdown_button__5Ru0h","item":"TnSnappboxDropdown_item__Bwjsf","link":"TnSnappboxDropdown_link__HrrbO","active":"TnSnappboxDropdown_active__1aFCX"};